import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { UseItemTriggerActionModel, MoveMapElementActionModel, MovePlayerActionModel, LooseItemActionModel, FinishQuestActionModel, ReceiveAwarenessActionModel, ReceiveItemActionModel, ReceiveQuestActionModel, ReceiveReputationActionModel, SetTagActionModel, SetVariableActionModel, StartDialogueActionModel, StartFightActionModel, TreeEnterActionModel, TreeExitActionModel, LocationTriggerActionModel, InteractionTriggerActionModel, ConditionTriggerActionModel, ConditionActionModel, TreeParamterActionModel, SetPlayStyleActionModel, ItemSelectionMode, TreePropertiesActionModel, AbortQuestActionModel, ReceiveTaskActionModel, FinishTaskActionModel, AbortTaskActionModel, ModifyPlayerHealthModel, CalculateVariableActionModel, ShowTextActionModel, ShowImageActionModel, StartTimerActionModel, CommentActionModel, PlayAnimationActionModel, DebugStartActionModel, TriggerDamageInAreaActionModel, StartActActionModel, SetReputationStatusActionModel, StopMapElementActionModel, SetPlayerInputActionModel, SetCameraActionModel, ShakeCameraActionModel, FadeCameraActionModel, SimpleCutSceneActionModel, PlaySoundActionModel, SetEmergencyLightingActionModel, DeactivateNodeGroupActionModel, CopyAwarenessIntoVariableActionModel } from '../../../shared/action/ActionModel';
import { StartFightActionDetails } from './details/StartFightActionDetails';
import { MoveMapElementActionDetails } from './details/MoveMapElementActionDetails';
import { ReceiveReputationActionDetails } from './details/ReceiveReputationActionDetails';
import { SetVariableActionDetails } from './details/SetVariableActionDetails';
import { StartDialogueActionDetails } from './details/StartDialogueActionDetails';
import { groupUndoableActionEditorChanges, ActionEditorChangeGroup } from '../../stores/undo/operation/ActionEditorSubmitChangesOp';
import { undoableActionEditorDeselectAction } from '../../stores/undo/operation/ActionEditorSelectActionOp';
import { MovePlayerActionDetails } from "./details/MovePlayerActionDetails";
import { lastElement } from '../../../shared/helper/generalHelpers';
import { MenuCard } from '../menu/MenuCard';
import { MenuCardLabel } from "../menu/MenuCardLabel";
import { StringActionDetail } from './details/components/StringActionDetail';
import { ReceiveQuestActionDetails } from './details/ReceiveQuestActionDetails';
import { QuestOrTaskActionDetail } from './details/QuestOrTaskActionDetail';
import { AreaTriggerActionDetails } from './details/AreaTriggerActionDetails';
import { ActionTreeDetails } from './details/ActionTreeDetails';
import { ActionTreeModel, getTreeParent } from '../../../shared/action/ActionTreeModel';
import { ConditionActionDetails } from './details/ConditionActionDetails';
import { TreeParameterActionDetails } from './details/TreeParameterActionDetails';
import { ItemSelectionActionDetail } from './details/components/ItemSelectionActionDetail';
import { SetPlayStyleActionDetails } from './details/SetPlayStyleActionDetails';
import { LooseItemActionDetails } from './details/LooseItemActionDetails';
import { TreePropertiesActionDetails } from './details/TreePropertiesActionDetails';
import { ReceiveTaskActionDetails } from './details/ReceiveTaskActionDetails';
import { NumberActionDetail } from './details/components/NumberActionDetail';
import { CalculateVariableActionDetails } from './details/CalculateVariableActionDetails';
import { PlayAnimationActionDetails } from './details/PlayAnimationActionDetails';
import { DisplayMode, TranslatedStringActionDetail } from './details/components/TranslatedStringActionDetail';
import { AutoResizeTextareaFullWidth } from '../shared/AutoResizeTextarea';
import { ImageSelectionActionDetail } from './details/components/ImageSelectionActionDetail';
import { InteractionTriggerActionDetails } from './details/InteractionTriggerActionDetails';
import { StartTimerActionDetails } from './details/StartTimerActionDetails';
import { TriggerDamageInAreaActionDetails } from './details/TriggerDamageInAreaActionDetails';
import { AiFillDelete } from "react-icons/ai";
import { MapElementSelectionDetail } from "./details/components/MapElementSelectionDetail";
import { MapElementFilter } from "../../helper/MapElementFilter";
import { StartActActionDetails } from './details/StartActActionDetails';
import { DebugStartActionDetails } from './details/DebugStartActionDetails';
import { useZoomPanHelper } from "react-flow-renderer";
import { CgEditBlackPoint } from 'react-icons/cg';
import { UiConstants } from "../../data/UiConstants";
import { toHumanReadableId } from "../../../shared/helper/actionTreeHelper";
import { SetCameraActionDetails } from "./details/SetCameraActionDetails";
import { SetPlayerInputActionDetail } from "./details/SetPlayerInputActionDetail";
import { ShakeCameraActionDetails } from "./details/ShakeCameraActionDetails";
import { FadeCameraActionDetails } from "./details/FadeCameraActionDetails";
import { SimpleCutSceneActionDetails } from "./details/SimpleCutSceneActionDetails";
import { actionEditorStore } from '../../stores/ActionEditorStore';
import { localSettingsStore } from '../../stores/LocalSettingsStore';
import { PlaySoundActionDetails } from "./details/PlaySoundActionDetails";
import { BooleanActionDetail } from './details/components/BooleanActionDetail';
import { undoableActionEditorDeleteSubtree } from '../../stores/undo/operation/ActionEditorDeleteSubtreeOp';
import { MdCleaningServices } from 'react-icons/md';
import { EditorComplexity } from '../../../shared/definitions/other/EditorComplexity';
import { CopyAwarenessIntoVariableDetails } from './details/CopyAwarenessIntoVariableDetails';
import { actionNodeIcon } from './actionNodeData';
import { ElementGroup } from './details/components/BaseElements';
import { gameStore } from '../../stores/GameStore';
const IconButton = styled.button.withConfig({
  displayName: "ActionDetails__IconButton",
  componentId: "sc-io8wgs-0"
})(["margin-left:4px;margin-right:4px;border:0;&:enabled{cursor:pointer;&:hover{color:red;}}"]);
const FlexRow = styled.div.withConfig({
  displayName: "ActionDetails__FlexRow",
  componentId: "sc-io8wgs-1"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
const SelectableText = styled.div.withConfig({
  displayName: "ActionDetails__SelectableText",
  componentId: "sc-io8wgs-2"
})(["font-size:small;font-family:monospace;cursor:text;-webkit-user-select:all;-moz-user-select:all;-ms-user-select:all;user-select:all;margin-top:2px;"]);
const IconContainer = styled.div.withConfig({
  displayName: "ActionDetails__IconContainer",
  componentId: "sc-io8wgs-3"
})(["display:flex;flex-direction:column;flex-grow:1;align-items:center;margin:4px;"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "ActionDetails__ButtonContainer",
  componentId: "sc-io8wgs-4"
})(["display:flex;flex-direction:row;flex-grow:0;flex-shrink:1;align-items:center;"]);
const TitleContainer = styled.div.withConfig({
  displayName: "ActionDetails__TitleContainer",
  componentId: "sc-io8wgs-5"
})(["background-color:", ";display:flex;flex-direction:column;margin-right:24px;flex-grow:1;border-radius:", ";border:1px solid black;margin-bottom:10px;"], props => props.color ? props.color : "#FFFFFF", UiConstants.BORDER_RADIUS);
const TitleText = styled(MenuCardLabel).withConfig({
  displayName: "ActionDetails__TitleText",
  componentId: "sc-io8wgs-6"
})(["display:flex;align-items:center;"]);
const PropertiesContainer = styled.div.withConfig({
  displayName: "ActionDetails__PropertiesContainer",
  componentId: "sc-io8wgs-7"
})(["margin:4px;"]);
const DebugRow = styled(FlexRow).withConfig({
  displayName: "ActionDetails__DebugRow",
  componentId: "sc-io8wgs-8"
})(["margin-left:24px;"]);
export const ActionDetails = observer(() => {
  var _action$treePropertie, _action$treePropertie2;

  const {
    t
  } = useTranslation();
  const {
    currentAction: action
  } = actionEditorStore;

  const deleteAction = () => {
    undoableActionEditorDeselectAction();

    if (action instanceof ActionTreeModel) {
      undoableActionEditorDeleteSubtree(action);
    } else {
      groupUndoableActionEditorChanges(ActionEditorChangeGroup.DeleteActionNode, () => {
        const actionTree = lastElement(actionEditorStore.currentActionTreeHierarchy);
        actionTree.removeNonSubtreeAction(action);
      });
    }
  };

  const allowSettingDeactivationGroupId = localSettingsStore.editorComplexity === EditorComplexity.Production && !(action instanceof ActionTreeModel);
  const hasDeactivationGroupId = action && action.deactivationGroupId.length > 0;
  const [showDeactivationGroupId, setShowDeactivationGroupId] = useState(hasDeactivationGroupId);
  useEffect(() => {
    setShowDeactivationGroupId(hasDeactivationGroupId);
  }, [action === null || action === void 0 ? void 0 : action.$modelId]);
  const deactivationGroupIdVisible = allowSettingDeactivationGroupId && (showDeactivationGroupId || hasDeactivationGroupId);
  const zoomPanHelper = useZoomPanHelper();
  const actionDetailsTop = 40;
  const navigatorHeight = 260; // In the MenuCard, "key={action?.$modelId}" is used to completely refresh the contents of the MenuCard.
  // This is necessary for e.g. switching between two StartDialogueActionModels to make sure all useState()
  // calls inside are fully refreshed and not automatically reused by React.

  return /*#__PURE__*/React.createElement(MenuCard, {
    minWidth: "200px",
    maxHeight: `calc(100vh - ${actionDetailsTop}px - ${navigatorHeight}px)`,
    key: action === null || action === void 0 ? void 0 : action.$modelId
  }, action && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleContainer, {
    color: action.nodeColor()
  }, /*#__PURE__*/React.createElement(FlexRow, null, /*#__PURE__*/React.createElement(TitleText, null, /*#__PURE__*/React.createElement(IconContainer, null, actionNodeIcon(action)), action instanceof ActionTreeModel && (_action$treePropertie = action.treePropertiesAction) !== null && _action$treePropertie !== void 0 && _action$treePropertie.localizedName.get(gameStore.languageKey) ? (_action$treePropertie2 = action.treePropertiesAction) === null || _action$treePropertie2 === void 0 ? void 0 : _action$treePropertie2.localizedName.get(gameStore.languageKey) : t(action.title())), /*#__PURE__*/React.createElement(ButtonContainer, null, allowSettingDeactivationGroupId && /*#__PURE__*/React.createElement(IconButton, {
    disabled: hasDeactivationGroupId,
    onClick: () => setShowDeactivationGroupId(!showDeactivationGroupId)
  }, /*#__PURE__*/React.createElement(MdCleaningServices, null)), action instanceof TreePropertiesActionModel || /*#__PURE__*/React.createElement(IconButton, {
    onClick: deleteAction
  }, /*#__PURE__*/React.createElement(AiFillDelete, null)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => actionEditorStore.jumpToAction(action, zoomPanHelper)
  }, /*#__PURE__*/React.createElement(CgEditBlackPoint, null)))), localSettingsStore.showDebugInfo && /*#__PURE__*/React.createElement(DebugRow, null, "id:\xA0", /*#__PURE__*/React.createElement(SelectableText, {
    onClick: e => actionEditorStore.debugLogInformation(action)
  }, toHumanReadableId(action === null || action === void 0 ? void 0 : action.$modelId)))), /*#__PURE__*/React.createElement(PropertiesContainer, null, action instanceof AbortQuestActionModel && /*#__PURE__*/React.createElement(QuestOrTaskActionDetail, {
    questId: action.questId,
    questIdSetter: action.setQuestId.bind(action),
    text: action.text,
    parentTree: getTreeParent(action)
  }), action instanceof AbortTaskActionModel && /*#__PURE__*/React.createElement(QuestOrTaskActionDetail, {
    questId: action.questId,
    questIdSetter: action.setQuestId.bind(action),
    taskId: action.taskId,
    taskIdSetter: action.setTaskId.bind(action),
    text: action.text,
    parentTree: getTreeParent(action)
  }), action instanceof ActionTreeModel && /*#__PURE__*/React.createElement(ActionTreeDetails, {
    action: action
  }), action instanceof CalculateVariableActionModel && /*#__PURE__*/React.createElement(CalculateVariableActionDetails, {
    action: action
  }), action instanceof CommentActionModel && /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_color"),
    value: action.color,
    valueSetter: action.setColor.bind(action),
    allowBlankValue: true
  }), action instanceof DebugStartActionModel && /*#__PURE__*/React.createElement(DebugStartActionDetails, {
    action: action
  }), action instanceof ConditionActionModel && !action.isPlayStyleCondition() && /*#__PURE__*/React.createElement(ConditionActionDetails, {
    condition: action.condition
  }), action instanceof ConditionTriggerActionModel && /*#__PURE__*/React.createElement(ConditionActionDetails, {
    condition: action.condition
  }), action instanceof FinishQuestActionModel && /*#__PURE__*/React.createElement(QuestOrTaskActionDetail, {
    questId: action.questId,
    questIdSetter: action.setQuestId.bind(action),
    text: action.text,
    parentTree: getTreeParent(action)
  }), action instanceof FinishTaskActionModel && /*#__PURE__*/React.createElement(QuestOrTaskActionDetail, {
    questId: action.questId,
    questIdSetter: action.setQuestId.bind(action),
    taskId: action.taskId,
    taskIdSetter: action.setTaskId.bind(action),
    text: action.text,
    parentTree: getTreeParent(action)
  }), action instanceof InteractionTriggerActionModel && /*#__PURE__*/React.createElement(InteractionTriggerActionDetails, {
    interactionTrigger: action.triggerElement,
    setInteractionTrigger: action.setTriggerElement.bind(action),
    iconType: action.iconType,
    setIconType: action.setIconType.bind(action)
  }), action instanceof MovePlayerActionModel && /*#__PURE__*/React.createElement(MovePlayerActionDetails, {
    action: action
  }), action instanceof PlayAnimationActionModel && /*#__PURE__*/React.createElement(PlayAnimationActionDetails, {
    action: action
  }), action instanceof LocationTriggerActionModel && /*#__PURE__*/React.createElement(AreaTriggerActionDetails, {
    action: action
  }), action instanceof LooseItemActionModel && /*#__PURE__*/React.createElement(LooseItemActionDetails, {
    action: action
  }), action instanceof UseItemTriggerActionModel && /*#__PURE__*/React.createElement(ItemSelectionActionDetail, {
    selectionMode: ItemSelectionMode.Item,
    selectionModeSetter: null,
    itemIdOrTags: action.itemId,
    itemIdOrTagsSetter: action.setItemId.bind(action),
    parentTree: getTreeParent(action)
  }), action instanceof ModifyPlayerHealthModel && /*#__PURE__*/React.createElement(NumberActionDetail, {
    name: t("action_editor.property_value") + " (+/-)",
    value: action.amount,
    valueSetter: action.setAmount.bind(action),
    validateNumber: value => value != 0
  }), action instanceof MoveMapElementActionModel && /*#__PURE__*/React.createElement(MoveMapElementActionDetails, {
    action: action
  }), action instanceof StopMapElementActionModel && /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: t("action_editor.property_map_element_stop"),
    selectedElement: action.mapElement,
    elementSetter: action.setMapElement.bind(action),
    parameterTypes: ["actions/NPCOnMapValueModel", "actions/EnemyOnMapValueModel"],
    getSelectableElements: MapElementFilter.filterNPCLabels
  }), action instanceof ReceiveAwarenessActionModel && /*#__PURE__*/React.createElement(NumberActionDetail, {
    name: t("action_editor.property_value") + " +",
    value: action.amount,
    valueSetter: action.setAmount.bind(action)
  }), action instanceof ReceiveItemActionModel && /*#__PURE__*/React.createElement(ItemSelectionActionDetail, {
    selectionMode: ItemSelectionMode.Item,
    selectionModeSetter: null,
    itemIdOrTags: action.itemId,
    itemIdOrTagsSetter: action.setItemId.bind(action),
    parentTree: getTreeParent(action)
  }), action instanceof ReceiveQuestActionModel && /*#__PURE__*/React.createElement(ReceiveQuestActionDetails, {
    action: action
  }), action instanceof ReceiveReputationActionModel && /*#__PURE__*/React.createElement(ReceiveReputationActionDetails, {
    action: action
  }), action instanceof ReceiveTaskActionModel && /*#__PURE__*/React.createElement(ReceiveTaskActionDetails, {
    action: action
  }), action instanceof SetPlayStyleActionModel && /*#__PURE__*/React.createElement(SetPlayStyleActionDetails, {
    action: action
  }), action instanceof SetTagActionModel && /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_tag"),
    value: action.tag,
    valueSetter: action.setTag.bind(action),
    allowBlankValue: false
  }), action instanceof SetVariableActionModel && /*#__PURE__*/React.createElement(SetVariableActionDetails, {
    action: action
  }), action instanceof ShowImageActionModel && /*#__PURE__*/React.createElement(ImageSelectionActionDetail, {
    imageId: action.imageId,
    imageIdSetter: action.setImageId.bind(action)
  }), action instanceof ShowTextActionModel && /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_text_neutral"),
    translatedString: action.text,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }), action instanceof StartDialogueActionModel && /*#__PURE__*/React.createElement(StartDialogueActionDetails, {
    action: action
  }), action instanceof StartFightActionModel && /*#__PURE__*/React.createElement(StartFightActionDetails, {
    action: action
  }), action instanceof StartTimerActionModel && /*#__PURE__*/React.createElement(StartTimerActionDetails, {
    action: action
  }), action instanceof StartActActionModel && /*#__PURE__*/React.createElement(StartActActionDetails, {
    action: action
  }), action instanceof CopyAwarenessIntoVariableActionModel && /*#__PURE__*/React.createElement(CopyAwarenessIntoVariableDetails, {
    action: action
  }), action instanceof SetReputationStatusActionModel && /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_reputation_status"),
    translatedString: action.status,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }), action instanceof TreeEnterActionModel && /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("editor.translated_name"),
    translatedString: action.name,
    allowBlankValue: true,
    displayMode: DisplayMode.Simple
  }), action instanceof TreeExitActionModel && /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("editor.translated_name"),
    translatedString: action.name,
    allowBlankValue: true,
    displayMode: DisplayMode.Simple
  }), action instanceof TreeParamterActionModel && /*#__PURE__*/React.createElement(TreeParameterActionDetails, {
    action: action
  }), action instanceof TreePropertiesActionModel && /*#__PURE__*/React.createElement(TreePropertiesActionDetails, {
    action: action
  }), action instanceof TriggerDamageInAreaActionModel && /*#__PURE__*/React.createElement(TriggerDamageInAreaActionDetails, {
    action: action
  }), action instanceof SetPlayerInputActionModel && /*#__PURE__*/React.createElement(SetPlayerInputActionDetail, {
    action: action
  }), action instanceof SetCameraActionModel && /*#__PURE__*/React.createElement(SetCameraActionDetails, {
    action: action
  }), action instanceof ShakeCameraActionModel && /*#__PURE__*/React.createElement(ShakeCameraActionDetails, {
    action: action
  }), action instanceof FadeCameraActionModel && /*#__PURE__*/React.createElement(FadeCameraActionDetails, {
    action: action
  }), action instanceof SimpleCutSceneActionModel && /*#__PURE__*/React.createElement(SimpleCutSceneActionDetails, {
    action: action
  }), action instanceof PlaySoundActionModel && /*#__PURE__*/React.createElement(PlaySoundActionDetails, {
    action: action
  }), action instanceof SetEmergencyLightingActionModel && /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_activate_emergency_lighting"),
    checked: action.activate,
    toggle: action.toggleActivate.bind(action)
  }), action instanceof DeactivateNodeGroupActionModel && /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_target_deactivation_group_id"),
    value: action.targetDeactivationGroupId,
    valueSetter: value => {
      action.setTargetDeactivationGroupId(value);
    },
    allowBlankValue: false
  }), /*#__PURE__*/React.createElement(ElementGroup, null, t("action_editor.node_comment"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AutoResizeTextareaFullWidth, {
    value: action.comment,
    onChange: ({
      target
    }) => action.setComment(target.value)
  })), deactivationGroupIdVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_deactivation_group_id"),
    value: action.deactivationGroupId,
    valueSetter: value => {
      action.setDeactivationGroupId(value);

      if (!showDeactivationGroupId) {
        setShowDeactivationGroupId(true);
      }
    },
    allowBlankValue: false
  })))));
});